import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from "../../AuthContext";
import { getAuth, updateProfile } from 'firebase/auth';
import { db, storage } from "../../firebase";
import { doc, collection, query, where, getDocs, updateDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faSave, faUpload } from '@fortawesome/free-solid-svg-icons';
import './Profile.css';
import Footer from '../../Components/Footer/Footer';
import Loading1 from "../../Components/Loading/Loading1";

function Profile() {
    const { user } = useContext(AuthContext);
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [newName, setNewName] = useState(user?.displayName || '');
    const [newEmail, setNewEmail] = useState(user?.email || '');
    const [newProfilePic, setNewProfilePic] = useState(user?.photoURL || '');
    const [profilePicFile, setProfilePicFile] = useState(null);
    const [editing, setEditing] = useState(false);

    useEffect(() => {
        const fetchOrders = async () => {
            try {
                if (user) {
                    const ordersQuery = query(collection(db, "orders"), where("userId", "==", user.uid));
                    const querySnapshot = await getDocs(ordersQuery);
                    const ordersList = querySnapshot.docs.map(doc => doc.data());
                    setOrders(ordersList);
                }
                setLoading(false);
            } catch (error) {
                console.error("Error fetching orders: ", error);
            }
        };

        fetchOrders();
    }, [user]);

    const handleProfileUpdate = async () => {
        if (user) {
            try {
                let profilePicUrl = newProfilePic;

                // If a new profile picture is uploaded
                if (profilePicFile) {
                    const storageRef = ref(storage, `profilePictures / ${user.uid}`);
                    await uploadBytes(storageRef, profilePicFile);
                    profilePicUrl = await getDownloadURL(storageRef);
                    setNewProfilePic(profilePicUrl); // Update state with new URL
                }

                // Update Auth Profile
                await updateProfile(user, { displayName: newName, photoURL: profilePicUrl });

                // Update Firestore user data
                const userDoc = doc(db, "users", user.uid);
                await updateDoc(userDoc, {
                    displayName: newName,
                    email: newEmail,
                    photoURL: profilePicUrl,
                });

                // Optionally, update the Auth email separately if needed
                if (newEmail !== user.email) {
                    await getAuth().currentUser.updateEmail(newEmail);
                }

                setEditing(false);
                alert('Profile updated successfully');
            } catch (error) {
                console.error('Error updating profile:', error);
            }
        }
    };

    const handleFileChange = (e) => {
        if (e.target.files[0]) {
            setProfilePicFile(e.target.files[0]);
        }
    };
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
        }, 1500);
    }, []);
    if (isLoading) {
        return <Loading1 />;
    }
    return (
        <>
            <div className="profilePage">
                <div className='profilepage-subcontainer'>
                    <h2 className="profileHeading">Profile</h2>
                    <div className="userDetails">
                        <p><strong>Name:</strong>
                            {editing ? (
                                <input
                                    type="text"
                                    value={newName}
                                    onChange={(e) => setNewName(e.target.value)}
                                    className="profileInput"
                                />
                            ) : (
                                <span className="profileText">{user.displayName || "N/A"}</span>
                            )}
                            {editing ? (
                                <button onClick={handleProfileUpdate} className="profileButton"><FontAwesomeIcon icon={faSave} /> Save</button>
                            ) : (
                                <button onClick={() => setEditing(true)} className="profileButton"><FontAwesomeIcon icon={faEdit} /> Edit</button>
                            )}
                        </p>
                        <p><strong>Email:</strong>
                            {editing ? (
                                <input
                                    type="email"
                                    value={newEmail}
                                    onChange={(e) => setNewEmail(e.target.value)}
                                    className="profileInput"
                                />
                            ) : (
                                <span className="profileText">{user.email || "N/A"}</span>
                            )}
                        </p>
                        <p><strong>Phone:</strong> {user.phoneNumber || "N/A"}</p>
                    </div>

                    <h3 className="ordersHeading">Your Orders</h3>
                    {loading ? (
                        <p className="loadingText">Loading...</p>
                    ) : orders.length > 0 ? (
                        <ul className="orderList">
                            {orders.map((order, index) => (
                                <li key={index} className="orderListItem">
                                    <p><strong>Date:</strong> {order.serviceDate}</p>
                                    <p><strong>Time:</strong> {order.serviceTime}</p>
                                    <p><strong>Status:</strong> {order.status}</p>
                                    <p><strong>Total:</strong> {order.amount}</p>
                                    <p><strong>Service:</strong> {order.service.map(s => s.name).join(', ')}</p>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p className="noOrdersText">No orders found.</p>
                    )}
                </div>
            </div>
            <Footer />
        </>
    );
}

export default Profile;
